import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _isNil from "lodash-es/isNil";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import fetch, { Headers, Response } from 'node-fetch'; // todo conditionally use Web API fetch if in browser and node-fetch if in server (ENV var)

import { resolveAgency } from '../auth';
/** node-fetch v2 request timeout (ms). Omitted in browser (native fetch). */

export const DEFAULT_REQUEST_TIMEOUT_MS = 8000;
const requestTimeoutMs = typeof window === 'undefined' ? DEFAULT_REQUEST_TIMEOUT_MS : undefined;
/**
 * Per-call `timeoutMs` raises the ceiling for endpoints known to run longer than
 * the default. Still omitted in the browser, whose native fetch has no timeout
 * option to honour.
 */

const timeoutOption = override => {
  if (requestTimeoutMs === undefined) {
    return {};
  }

  return {
    timeout: override !== null && override !== void 0 ? override : requestTimeoutMs
  };
};

export function isResponse(response) {
  return response instanceof Response;
}

function isPostOptions(options) {
  return 'data' in options;
}

const baseOptions = {
  headers: {},
  qs: {}
}; // TODO: Better error handling.

export class Request {
  constructor({
    url,
    signal,
    keycloak
  }) {
    _defineProperty(this, "url", void 0);

    _defineProperty(this, "signal", void 0);

    _defineProperty(this, "basePath", void 0);

    _defineProperty(this, "baseParams", {});

    _defineProperty(this, "keycloak", void 0);

    _defineProperty(this, "commonHeaders", {
      Authorization: '',
      'Content-Type': 'application/json',
      Accept: 'application/json'
    });

    _defineProperty(this, "tokenExpirytime", parseInt(process.env.REACT_APP_TOKEN_VALIDITY_IN_SECONDS));

    this.url = new URL(url);
    this.basePath = this.url.pathname;
    this.signal = signal;
    this.keycloak = keycloak;
  }

  setParam(key, value) {
    this.url.searchParams.set(key, value);
  }

  deleteParam(key) {
    this.url.searchParams.delete(key);
  }

  mergeOptions(options) {
    const newOpts = _objectSpread(_objectSpread({}, baseOptions), options);

    return isPostOptions(newOpts) ? newOpts : newOpts;
  }

  getPathName(api) {
    if (this.basePath !== '/') {
      return this.basePath + (api.startsWith('/') ? api : `/${api}`);
    }

    return api;
  }
  /**
   * Split this functionality out from the "setup" method so that it can be overridden
   * in the PimPgRest class for building the queryparms portion of the url.
   *
   * Null/undefined values are explicitly deleted from the shared URL so that a concurrent
   * call's stale params (e.g. fromdate/todate set by getPrintPatientMeasures) don't leak
   * into a call that intentionally omits those params (e.g. getPrintProgressNotes with
   * meeting_id only). Without this, the shared this.url accumulates params across
   * concurrent calls until cleanup() runs in .finally().
   */


  setParamsFromQs(queryString) {
    if (queryString) {
      Object.entries(queryString).forEach(([k, v]) => {
        if (!_isNil(v)) {
          this.setParam(k, v);
        } else {
          this.deleteParam(k);
        }
      });
    }
  } // Re-apply baseParams for any key the current call's qs did not already set,
  // so sticky params (e.g. agency) survive setup()'s clear-all without
  // overriding a per-call value.


  applyBaseParamsForMissingKeys() {
    Object.entries(this.baseParams).forEach(([k, v]) => {
      if (!_isNil(v) && !this.url.searchParams.has(k)) {
        this.setParam(k, v);
      }
    });
  } // Interceptor: guarantee every outbound call carries an agency param. Runs
  // only after qs and baseParams, so an explicit per-call or constructor agency
  // always wins. Falls back to URL / localStorage / keycloak token.


  ensureAgencyParam() {
    if (!this.url.searchParams.has('agency')) {
      const agency = resolveAgency(undefined, this.keycloak);

      if (agency) {
        this.setParam('agency', agency);
      }
    }
  }

  async refreshToken(keycloak) {
    const tokenExpirytime = parseInt(process.env.REACT_APP_TOKEN_VALIDITY_IN_SECONDS);

    if (keycloak !== null && keycloak !== void 0 && keycloak.updateToken) {
      await keycloak.updateToken(tokenExpirytime).success(refreshed => {
        if (refreshed) {
          // Token was successfully refreshed
          this.commonHeaders.Authorization = `Bearer ${keycloak.token}`;
        } // Token is still valid

      }).error(error => {
        console.log('error', error); // Failed to refresh the token, or the session has expired
        // keycloak.logout();
      });
    }
  }

  setup(options) {
    const mergedOptions = this.mergeOptions(options); // Shared URL instance: drop every query param before applying this call's qs
    // so parallel get() on the same Request cannot leak params (e.g. CPP submode
    // onto patientmanifest/id/v2, or category/type onto patientdaterange).

    [...this.url.searchParams.keys()].forEach(k => {
      this.deleteParam(k);
    });
    this.setParamsFromQs(mergedOptions.qs);
    this.applyBaseParamsForMissingKeys();
    this.ensureAgencyParam(); //  if (mergedOptions.qs) {
    //    Object.entries(mergedOptions.qs).forEach(([k, v]) => {
    //      if (!isNil(v)) {
    //        this.setParam(k, v);
    //      }
    //    });
    //  }

    this.url.pathname = this.getPathName(mergedOptions.api);
    return mergedOptions;
  }

  cleanup(options) {
    Object.keys(options.qs).forEach(k => {
      this.deleteParam(k);
    });
  }
  /* eslint-disable @typescript-eslint/no-explicit-any */


  parseJSON(response) {
    /* eslint-enable */
    if (response.status === 204 || response.status === 205) {
      return null;
    }

    const contentType = response.headers.get('content-type');

    if (response.ok && typeof contentType === 'string' && contentType.includes('application/json')) {
      // text() + JSON.parse avoids node-fetch v2 response.json() failures on large bodies
      // (parallel clone fallback previously returned a raw Response and broke print paths).
      return response.text().then(text => {
        try {
          return JSON.parse(text);
        } catch (err) {
          if (typeof window === 'undefined') {
            // eslint-disable-next-line no-console
            console.log(`[Request] JSON parse failed status=${response.status} len=${text.length} err=${err}`);
          }

          return new Response(text, {
            status: response.status,
            statusText: response.statusText,
            headers: response.headers
          });
        }
      });
    }

    return response;
  }

  async get(args = {
    headers: {},
    qs: {}
  }) {
    let options;

    if (typeof args === 'string') {
      options = _objectSpread(_objectSpread({}, baseOptions), {}, {
        api: args
      });
    } else {
      options = args;
    }

    await this.refreshToken(this.keycloak);
    const mergedOptions = this.setup(options);
    return fetch(this.url.href, _objectSpread(_objectSpread({
      method: 'GET',
      mode: 'cors',
      signal: this.signal
    }, timeoutOption(mergedOptions.timeoutMs)), {}, {
      headers: new Headers(_objectSpread(_objectSpread({}, this.commonHeaders), mergedOptions.headers))
    })).then(this.parseJSON).finally(() => {
      this.cleanup(mergedOptions);
    });
  }

  async post(args = {
    headers: {},
    qs: {}
  }) {
    let options;

    if (typeof args === 'string') {
      options = _objectSpread(_objectSpread({}, baseOptions), {}, {
        api: args
      });
    } else {
      options = args;
    }

    options.method = options.method || 'POST';
    await this.refreshToken(this.keycloak);
    const mergedOptions = this.setup(options);
    return fetch(this.url.href, _objectSpread(_objectSpread({
      method: mergedOptions.method,
      mode: 'cors',
      signal: this.signal
    }, timeoutOption(mergedOptions.timeoutMs)), {}, {
      headers: new Headers(_objectSpread(_objectSpread({}, this.commonHeaders), mergedOptions.headers)),
      body: typeof options.data === 'string' ? options.data : JSON.stringify(options.data)
    })).then(this.parseJSON).finally(() => {
      this.cleanup(mergedOptions);
    });
  }

  async delete(args = {
    headers: {},
    qs: {}
  }) {
    let options;

    if (typeof args === 'string') {
      options = _objectSpread(_objectSpread({}, baseOptions), {}, {
        api: args
      });
    } else {
      options = args;
    }

    options.method = options.method || 'DELETE';
    await this.refreshToken(this.keycloak);
    const mergedOptions = this.setup(options);
    return fetch(this.url.href, _objectSpread(_objectSpread({
      method: 'DELETE',
      mode: 'cors',
      signal: this.signal
    }, timeoutOption(mergedOptions.timeoutMs)), {}, {
      headers: new Headers(_objectSpread(_objectSpread({}, this.commonHeaders), mergedOptions.headers)),
      body: typeof options.data === 'string' ? options.data : JSON.stringify(options.data)
    })).then(this.parseJSON).finally(() => {
      this.cleanup(mergedOptions);
    });
  }

}
export default Request;